import request from '@/utils/request'
import { activityInfoRequest, activityInfoResponse } from '@/api/exclusive'

export type cityTaskResponse = {
  visited: boolean
  taskGroups: {
    groupId: number
    groupName: string
    tasks: {
      description: string
      difficulty: number
      finishStatus: number
      id: number
      qBtnTxt: string
      qDesc: string
      qImg: string
      qName: string
      qUrl: string
      rewardTypeIntegral: number // 是否有积分奖励：1、是；0、否
      integralRewardNum?: number // 积分奖励数值
      rewardTypeCode: number // 是否有卡券奖励：1、是；0、否
      codeRewardDescription?: string // 卡券奖励三语言说明
      rewardTypeOther: number // 是否有其他奖励
      rewardOtherDescription?: string // 其他奖励三语言说明
    }[]
  }[]
}
export type signInfoResponse = {
  detail: {
    signDetail: {
      center: {
        isSignIn: boolean
        user: {
          integral: number | string
        }
      }
      reminder: boolean
      totalCount: number
    }
  }
}
export type switchInfo = {
  status: number
}
export type switchResponse = {
  detail: {}
}
export type signInResponse = {
  resultCode: number
}
export type verifyCodeRequest = {
  code: string
}
export type verifyCodeResponse = {
  resultCode: number
}
export type couponCodeRequest = {
  couponCode: string
  verifyCode: string
}
export type couponCodeResponse = {
  resultCode: number
  couponIntegral: number
}
export type shouldPopUpResponse = {
  resultBool: boolean
}
export type taskCenterRequest = {
  parentModelId: number
  pageNum: number
  pageSize: number
}
export type taskCenterResponse = {
  imageUrl: string
  linkUrl: string
  subTitle: string
  title: string
  taskId: number
  totalPoints: number
  taskStatus: number
  reward?: string
}[]

//新增任务tab下 任务 和 game 列表的item类型
export type getMissionParkTasksListItem = {
  description: string
  difficulty: number
  finishStatus: number// 1 已完成 2未完成-有库存 3未完成-无库存
  id: number
  qBtnTxt: string
  qDesc: string
  qImg: string
  qName: string
  qUrl: string
  rewardTypeIntegral: number // 是否有积分奖励：1、是；0、否
  integralRewardNum?: number // 积分奖励数值
  rewardTypeCode: number // 是否有卡券奖励：1、是；0、否
  codeRewardDescription?: string // 卡券奖励三语言说明
  rewardTypeOther: number // 是否有其他奖励
  rewardOtherDescription?: string // 其他奖励三语言说明
  jumpIntegralTask:number //是否逛一逛 0 不是 1是
}
//合并game列表 热门任务列表后的接口响应结构
export type getMissionParkTasksListType = {
  visited: boolean
  normalTask: Array<getMissionParkTasksListItem>
  gameTask:Array<getMissionParkTasksListItem>
  allTaskFinished:boolean


}
//获取任务信息
export function getCityTask() {
  return request<cityTaskResponse>({
    url: '/v1/api/ad/homepage/task/group/vCityTask',
    method: 'get'
  })
}
//签到积分信息
export function getSignInfo() {
  return request<signInfoResponse>({
    url: '/v1/api/eas/sign/detail',
    method: 'get'
  })
}

//提醒开关
export function switchChange(data: number) {
  return request<switchResponse>({
    url: `/v1/api/eas/sign/reminderSwitch?status=${data}`,
    method: 'get'
  })
}

//签到
export function signInToday(data: string) {
  return request<signInResponse>({
    url: `/v1/api/eas/sign/sign_in?userId=${data}`,
    method: 'get'
  })
}

//发送验证码
export function verifyCode(data: verifyCodeRequest) {
  return request<verifyCodeResponse>({
    url: '/v1/api/ad/homepage/integral/sendIntegralCouponVerifyCode',
    method: 'post',
    data
  })
}

//校验积分码
export function couponCode(data: couponCodeRequest) {
  return request<couponCodeResponse>({
    url: '/v1/api/ad/homepage/integral/exchangeIntegralCoupon',
    method: 'post',
    data
  })
}
//签到
export function shouldPopUpGuide() {
  return request<shouldPopUpResponse>({
    url: '/v1/api/eas/taskCity/shouldPopUpGuide',
    method: 'get'
  })
}
// 盲盒==================
export function blindBoxInfo() {
  return request<shouldPopUpResponse>({
    url: '/v1/api/eas/user/blindBoxInfo',
    method: 'post'
  })
}

// ubd api
export function taskCenterInfo(data: taskCenterRequest) {
  return request<taskCenterResponse>({
    url: '/v1/api/ad/homepage/task/group/taskCenterConsortium',
    method: 'GET',
    params: data
  })
}

// game tablist
export function getGameTask() {
  return request<cityTaskResponse>({
    url: '/v1/api/ad/homepage/task/group/gameTask',
    method: 'GET',
  })
}

// 热门任务和gamelist 的合并接口 10.8新接口 不再使用getGameTask 和 getCityTask
export function getMissionParkTasks() {
  return request<getMissionParkTasksListType>({
    url: "/v1/api/ad/homepage/task/group/missionParkTasks",
    method: "get"
  })
}

